export const options = [{ label: "UGX", value: "UGX" }]
export const getData = (key = "") => {
  let data = [
    {
      DayOfMonth: 1,
      Currency: "UGX",
      UniquePlayers: 45,
      TotalStake: 60924,
      StakeTax: "0",
      EffectiveStake: 60924,
      Boost: "0",
      WHT: "0",
      Payout: 28371,
      GGR: 32553,
    },
    {
      DayOfMonth: 2,
      Currency: "UGX",
      UniquePlayers: 48,
      TotalStake: 168402,
      StakeTax: "0",
      EffectiveStake: 168402,
      Boost: "0",
      WHT: "0",
      Payout: 111867.5,
      GGR: 56534.5,
    },
    {
      DayOfMonth: 3,
      Currency: "UGX",
      UniquePlayers: 51,
      TotalStake: 159547.5,
      StakeTax: "0",
      EffectiveStake: 159547.5,
      Boost: "0",
      WHT: "0",
      Payout: 106491.5,
      GGR: 53056,
    },
    {
      DayOfMonth: 4,
      Currency: "UGX",
      UniquePlayers: 48,
      TotalStake: 49850,
      StakeTax: "0",
      EffectiveStake: 49850,
      Boost: "0",
      WHT: "0",
      Payout: 6185,
      GGR: 43665,
    },
    {
      DayOfMonth: 5,
      Currency: "UGX",
      UniquePlayers: 50,
      TotalStake: 67980.06,
      StakeTax: "0",
      EffectiveStake: 67980.06,
      Boost: "0",
      WHT: "0",
      Payout: 25416.28,
      GGR: 42563.78,
    },
    {
      DayOfMonth: 6,
      Currency: "UGX",
      UniquePlayers: 82,
      TotalStake: 219840,
      StakeTax: "0",
      EffectiveStake: 219840,
      Boost: "0",
      WHT: "0",
      Payout: 169255,
      GGR: 50585,
    },
    {
      DayOfMonth: 7,
      Currency: "UGX",
      UniquePlayers: 55,
      TotalStake: 265203.9,
      StakeTax: "0",
      EffectiveStake: 265203.9,
      Boost: "0",
      WHT: "0",
      Payout: 148469.64,
      GGR: 116734.26,
    },
    {
      DayOfMonth: 8,
      Currency: "UGX",
      UniquePlayers: 25,
      TotalStake: 18135,
      StakeTax: "0",
      EffectiveStake: 18135,
      Boost: "0",
      WHT: "0",
      Payout: 4103,
      GGR: 14032,
    },
    {
      DayOfMonth: 9,
      Currency: "UGX",
      UniquePlayers: 26,
      TotalStake: 18035,
      StakeTax: "0",
      EffectiveStake: 18035,
      Boost: "0",
      WHT: "0",
      Payout: 1751,
      GGR: 16284,
    },
    {
      DayOfMonth: 10,
      Currency: "UGX",
      UniquePlayers: 24,
      TotalStake: 31580,
      StakeTax: "0",
      EffectiveStake: 31580,
      Boost: "0",
      WHT: "0",
      Payout: 2000,
      GGR: 29580,
    },
    {
      DayOfMonth: 11,
      Currency: "UGX",
      UniquePlayers: 35,
      TotalStake: 53326,
      StakeTax: "0",
      EffectiveStake: 53326,
      Boost: "0",
      WHT: "0",
      Payout: 11594.86,
      GGR: 41731.14,
    },
    {
      DayOfMonth: 12,
      Currency: "UGX",
      UniquePlayers: 26,
      TotalStake: 52750,
      StakeTax: "0",
      EffectiveStake: 52750,
      Boost: "0",
      WHT: "0",
      Payout: 18100,
      GGR: 34650,
    },
    {
      DayOfMonth: 13,
      Currency: "UGX",
      UniquePlayers: 19,
      TotalStake: 43100,
      StakeTax: "0",
      EffectiveStake: 43100,
      Boost: "0",
      WHT: "0",
      Payout: 17125,
      GGR: 25975,
    },
    {
      DayOfMonth: 14,
      Currency: "UGX",
      UniquePlayers: 27,
      TotalStake: 29800.06,
      StakeTax: "0",
      EffectiveStake: 29800.06,
      Boost: "0",
      WHT: "0",
      Payout: 0.14,
      GGR: 29799.92,
    },
    {
      DayOfMonth: 15,
      Currency: "UGX",
      UniquePlayers: 25,
      TotalStake: 45858,
      StakeTax: "0",
      EffectiveStake: 45858,
      Boost: "0",
      WHT: "0",
      Payout: 14754.2,
      GGR: 31103.8,
    },
    {
      DayOfMonth: 16,
      Currency: "UGX",
      UniquePlayers: 20,
      TotalStake: 31042,
      StakeTax: "0",
      EffectiveStake: 31042,
      Boost: "0",
      WHT: "0",
      Payout: 7905.82,
      GGR: 23136.18,
    },
    {
      DayOfMonth: 17,
      Currency: "UGX",
      UniquePlayers: 12,
      TotalStake: 1979705.2,
      StakeTax: "0",
      EffectiveStake: 1979705.2,
      Boost: "0",
      WHT: "0",
      Payout: 1902892,
      GGR: 76813.2,
    },
    {
      DayOfMonth: 18,
      Currency: "UGX",
      UniquePlayers: 17,
      TotalStake: 146000.12,
      StakeTax: "0",
      EffectiveStake: 146000.12,
      Boost: "0",
      WHT: "0",
      Payout: 85291.16,
      GGR: 60708.96,
    },
    {
      DayOfMonth: 19,
      Currency: "UGX",
      UniquePlayers: 12,
      TotalStake: 42800,
      StakeTax: "0",
      EffectiveStake: 42800,
      Boost: "0",
      WHT: "0",
      Payout: 11828.72,
      GGR: 30971.28,
    },
    {
      DayOfMonth: 20,
      Currency: "UGX",
      UniquePlayers: 76,
      TotalStake: 111200,
      StakeTax: "0",
      EffectiveStake: 111200,
      Boost: "0",
      WHT: "0",
      Payout: 78737,
      GGR: 32463,
    },
    {
      DayOfMonth: 21,
      Currency: "UGX",
      UniquePlayers: 41,
      TotalStake: 360700,
      StakeTax: "0",
      EffectiveStake: 360700,
      Boost: "0",
      WHT: "0",
      Payout: 176268.65,
      GGR: 184431.35,
    },
    {
      DayOfMonth: 22,
      Currency: "UGX",
      UniquePlayers: 30,
      TotalStake: 963650,
      StakeTax: "0",
      EffectiveStake: 963650,
      Boost: "0",
      WHT: "0",
      Payout: 814913.5,
      GGR: 148736.5,
    },
    {
      DayOfMonth: 23,
      Currency: "UGX",
      UniquePlayers: 16,
      TotalStake: 187100,
      StakeTax: "0",
      EffectiveStake: 187100,
      Boost: "0",
      WHT: "0",
      Payout: 129432,
      GGR: 57668,
    },
    {
      DayOfMonth: 24,
      Currency: "UGX",
      UniquePlayers: 14,
      TotalStake: 171000,
      StakeTax: "0",
      EffectiveStake: 171000,
      Boost: "0",
      WHT: "0",
      Payout: 152685,
      GGR: 18315,
    },
    {
      DayOfMonth: 25,
      Currency: "UGX",
      UniquePlayers: 11,
      TotalStake: 12000,
      StakeTax: "0",
      EffectiveStake: 12000,
      Boost: "0",
      WHT: "0",
      Payout: 4700,
      GGR: 7300,
    },
  ]

  return data
}
